import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function Benefits() {
  const benefits = [
    {
      title: "Initial Consultation and Discovery",
      description:
        "Understands business needs and identifies key challenges.",
    },
    {
      title: "Technology Assessment and Analysis",
      description:
        "Evaluates existing systems and identifies improvement areas.",
    },
    {
      title: "Strategy Development and Roadmap Creation",
      description:
        "Crafts a tailored IT strategy with a clear action plan.",
    },
    {
      title: "Solution Design and Technology Selection",
      description:
        "Develops solutions and selects the best-fit technologies.",
    },
    {
      title: "Implementation and Project Management",
      description:
        "Executes the plan and ensures seamless project delivery.",
    },
    {
      title: "Change Management and Training",
      description:
        "Prepares teams for transition and provides necessary training.",
    },
    {
      title: "Continuous Monitoring and Optimization",
      description:
        "Tracks performance and enhances solutions over time.",
    },
    {
      title: "Strategic Review and Future Planning",
      description:
        "Revisits goals and aligns strategies for long-term growth.",
    },
  ];
  return (
    <>
      <section className="py-5" style={{ backgroundColor: "#f8f8f8" }}>
      <Container>
        {/* Section Title */}
        <div className="text-center mb-4">
          <h2 className="fw-bold mb-4" style={{ color: "#0e2b5c" }}>
            Our Process
          </h2>
        </div>

        {/* Benefits Row */}
        <Row className="g-4">
          {benefits.map((benefit, index) => (
            <Col md={3} key={index} className="text-left mb-5" style={{padding:'0 15px'}}>
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className="ben-title mt-4 mb-3">{benefit.title}</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>{benefit.description}</h6>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

    </>
  )
}